<template lang="pug">
article-item-page-template(:title="pageTitle", :loading="loading")
  template(#main)
    v-expansion-panels
      v-expansion-panel.mb-2(v-for="({ title, text }, i) in items", :key="i")
        v-expansion-panel-header.py-6
          div
            v-icon.mt-n1(small, left) fas fa-exclamation-circle
            span.font-weight-bold.grey--text.text--darken-4(v-html="title")
        v-expansion-panel-content.pa-4.ck-content(v-html="text")
  template(#side)
    communications-widget
</template>

<script>
import ArticleItemPageTemplate from "@/components/templates/ArticleItemPage.vue";
import CommunicationsWidget from "@/components/widgets/Communications";

const _config = {
  mod: "tips",
  title: "Dicas Interessantes",
};

export default {
  data: () => ({
    pageTitle: _config.title,
    loading: true,
  }),
  computed: {
    items() {
      return this.$rest(_config.mod).list;
    },
  },
  created() {
    this.loading = true;

    this.$rest(_config.mod)
      .get({ keepCache: true })
      .then(() => (this.loading = false))
      .catch(() => {
        this.$router.replace("/error404");
      });
  },
  components: {
    ArticleItemPageTemplate,
    CommunicationsWidget,
  },
};
</script>
